/* flow-disable */

import React from 'react';
import { formatDate, DATE_FORMAT } from '@shootsta/get-moment';
import cx from 'classnames';

import { DATA_TABLE_COLUMN_DATA_TYPE } from '../../../common/constants/column/dataTableColumnDataType';
import { DATA_TABLE_ALIGN_HORIZONTAL } from '../../../common/constants/dataTableAlignHorizontal';
import {
  Image,
  Avatar,
  Button,
  ActionPopup,
  Text } from
'../../../ui-kit';
import AssetPreview from '../../AssetPreview';

const TEMPLATE_TYPES = Object.freeze({
  BLANK: 'Blank',
  PROMO: 'Promotional',
  FREE_FORM: 'Free form'
});

const getTemplatesDataTableColumns = ({
  isInternalAdmin,
  onPublish,
  onUnPublish,
  options,
  isMobile






}) => [
...(!isMobile ? [
{
  field: 'templatePreview',
  isSortable: false,
  dataType: DATA_TABLE_COLUMN_DATA_TYPE.TEXT,
  getStyleModifiers: (rawValue, row) => ({
    customClassName: cx(
      'template-data-table__cell',
      { 'template-data-table__cell--published': row.status === 'PUBLISHED' })
  }),
  getValue: (rawValue, row) => {
    const { previewAssetId, thumbnailAssetId } = row;
    const assetId = previewAssetId || thumbnailAssetId;

    if (!assetId) {
      return (
        <Image
          width="160px"
          height="90px"
          backgroundSize="contain"
          defaultImageIcon="video"
          defaultIconBackground="sterling"
          defaultIconColour="regent" />);


    }

    return (
      <AssetPreview
        assetId={assetId}
        hideFileTypeIcon
        canPlayVideo
        darkMode
        width="160px"
        height="90px" />);


  }
}] :
[]),
{
  field: 'templateName',
  header: isInternalAdmin ? 'Name' : '',
  isSortable: isInternalAdmin,
  dataType: DATA_TABLE_COLUMN_DATA_TYPE.TEXT,
  getStyleModifiers: (rawValue, row) => ({
    customClassName: isMobile ? cx(
      'template-data-table__cell',
      { 'template-data-table__cell--published': row.status === 'PUBLISHED' }) : ''
  }),
  getValue: (rawValue, row) =>
  <div>
        <Text className="template-data-table__title-heading" heading5>{row.templateName}</Text>
        <Text
      prefixIcon="link"
      disabled={!row.splashTemplateName}
      success={row.splashTemplateName}
      highlighted
      className="template-data-table__link-elevate">

          {row.splashTemplateName ? row.splashTemplateName : 'Not linked to any Splash page'}
        </Text>
      </div>

},
...(!isMobile ? [
...(!isInternalAdmin ? [
{
  field: 'type',
  isSortable: false,
  dataType: DATA_TABLE_COLUMN_DATA_TYPE.TEXT,
  getValue: (rawValue, row) =>
  <div>
            <Text>
              {
      row.templateType && TEMPLATE_TYPES[row.templateType] ?
      TEMPLATE_TYPES[row.templateType] :
      ''}

            </Text>
          </div>

}] :
[]),
{
  field: 'updatedAt',
  header: isInternalAdmin ? 'Last Updated' : '',
  isSortable: isInternalAdmin,
  dataType: DATA_TABLE_COLUMN_DATA_TYPE.TEXT,
  getValue: (rawValue, row) =>
  <Text>
          {formatDate(
      row.updatedAt,
      isInternalAdmin ?
      DATE_FORMAT.DAY_SHORT_FULL_MONTH_COMMA_YEAR_AT_TIME :
      DATE_FORMAT.MONTH_SHORT_DAY_YEAR
    )}
        </Text>

},
...(isInternalAdmin ? [
{
  field: 'isGlobal',
  header: 'Global',
  dataType: DATA_TABLE_COLUMN_DATA_TYPE.TEXT,
  getValue: (rawValue, row) =>
  <>
            {Number(row.isGlobal) === 1 ?
    <Image
      width="80px"
      height="80px"
      backgroundSize="contain"
      defaultImageIcon="web"
      defaultIconBackground="white"
      defaultIconColour="regent" /> :

    ''}
          </>

},
{
  field: 'createdBy',
  header: 'Created By',
  dataType: DATA_TABLE_COLUMN_DATA_TYPE.TEXT,
  getValue: (rawValue, row) =>
  <Avatar imageUrl={row.imageUrl} title={row.createdBy} />

}] :
[]),
{
  field: 'status',
  header: '',
  dataType: DATA_TABLE_COLUMN_DATA_TYPE.TEXT,
  isSortable: false,
  alignHorizontal: DATA_TABLE_ALIGN_HORIZONTAL.CENTER,
  getValue: (rawValue, row) => {
    if (row.status === 'PUBLISHED') {
      return (
        <Button type="TERTIARY" className="action-button" onClick={() => onUnPublish(row.templateId)}>
              Unpublish
            </Button>);

    }

    if (row.status === 'UNPUBLISHED') {
      return (
        <Button type="SECONDARY" className="action-button" onClick={() => onPublish(row.templateId)}>
              Publish
            </Button>);

    }

    return (
      <Button type="SECONDARY" className="action-button" disabled>
            Publish
          </Button>);

  }
}] :
[]),
{
  field: 'templateId',
  header: '',
  dataType: DATA_TABLE_COLUMN_DATA_TYPE.TEXT,
  isSortable: false,
  getValue: (rawValue, row) =>
  <ActionPopup
    options={options(row.templateId, row.status, row.templateVersion)} />


}];

/* flow-disable */

export default getTemplatesDataTableColumns;